export const metricsDisplayParams = [
  { id: 'time', name: 'Zeit', icon: 'timer', },
  { id: 'cost', name: 'Kosten', icon: 'euro_symbol', },
  { id: 'co2', name: 'CO₂', icon: 'filter_drama', },
  { id: 'sport', name: 'Bewegung', icon: 'directions_run', },
]

// route modes from hafas
export const routeModesOEPV = {
  waiting:  { icon: 'timer', name: 'Puffer' },
  foot:     { icon: 'directions_walk',    name: 'Zu Fuß', },
  bike: { icon: 'directions_bike', name: 'Fahrrad', },
  escooter: { icon: 'electric_scooter', name: 'e-Scooter', },
  car:      { icon: 'directions_car',     name: 'Auto', },
  ferry:    { icon: 'directions_boat',    name: 'Fähre', },
  bus:      { icon: 'directions_bus',     name: 'Bus', },
  national: { icon: 'directions_railway', name: 'IC', },
  regional: { icon: 'directions_transit', name: 'RE', },
  subway:   { icon: 'subway',             name: 'U', },
  taxi:     { icon: 'local_taxi',         name: 'Taxi', },
  tram:     { icon: 'tram',               name: 'Tram', },
  suburban: { icon: 'directions_transit', name: 'S', },
  nationalExpress: { icon: 'directions_railway', name: 'ICE' },
  regionalExp: { icon: 'directions_transit', name: 'RE' } 
}

// route modes from hafas
export const ownVehiclesMapping = {
  ebike:  { icon: 'electric_bike', name: 'e-Bike' },
  bike: { icon: 'directions_bike', name: 'Fahrrad', },
  escooter: { icon: 'electric_scooter', name: 'e-Scooter', },
  car:      { icon: 'directions_car',     name: 'Auto', },
  ecar:      { icon: 'electric_car',     name: 'e-Auto', },
  taxi:     { icon: 'local_taxi',         name: 'Taxi', },
  bikescooter:     { icon: 'bike_scooter',         name: 'Motorroller', },
  
}

// reversed Mapping of routingMode (e.g. bus, tram etc.) of a leg from Hafas (if it is a HAFAS-Query), e.g. train_long_distance here stands for national and nationalExpress in Hafas
export const reversedRouteModesOEPV = {
train_long_distance: { icon: 'directions_railway', name: 'IC & ICE' },
train_short_distance: { icon: 'directions_transit', name: 'RE & RB & S-Bahn' },
tram_and_metro: { icon: 'tram', name: 'Tram & Metro' },
bus_long_distance: { icon: 'directions_bus', name: 'Fernbus' },
bus_short_distance: { icon: 'directions_bus', name: 'Linienbus & Sammeltaxi' }
}
